function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

export { canUseDOM };